import React, { forwardRef } from "react";

import styles from "./LogbookCard.module.scss";

export const CardContainer = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    userAllowed?: string;
    open?: boolean;
  }
>(({ userAllowed, open, children, className, ...rest }, ref) => (
  <div
    ref={ref}
    className={`${styles.cardContainer} ${userAllowed === "true" ? "" : styles.restricted} ${open ? styles.open : ""} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
));

CardContainer.displayName = "CardContainer";

export const NoEntries: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
}) => <p className={styles.noEntries}>{children}</p>;

export const BottomText: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
}) => <p className={styles.bottomText}>{children}</p>;

export const CardName: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <p className={`${styles.cardName} ${className ?? ""}`} {...rest}>
    {children}
  </p>
);

export const ButtonContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.buttonContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
